export const TRANSACTION_STYLE_COLORS = {
  primary: '#0b6e99',
  foreground: '#0f172a',
  text: '#334155',
  muted: '#64748b',
  placeholder: '#94a3b8',
  subtle: '#94a3b8',
  border: '#cbd5e1',
  separator: '#e2e8f0',
  hover: '#f1f5f9',
  hoverControl: '#f1f5f9',
  rowHover: '#f8fafc',
  selected: '#f0f9ff',
  white: '#ffffff'
};

export const TRANSACTION_PICKER_THEME_OPTIONS = {
  palette: {
    primary: {
      main: TRANSACTION_STYLE_COLORS.primary,
      contrastText: TRANSACTION_STYLE_COLORS.white
    }
  },
  components: {
    MuiClock: {
      styleOverrides: {
        amButton: ({ ownerState }) => {
          const selected = ownerState?.meridiemMode === 'am';
          return {
            backgroundColor: selected ? TRANSACTION_STYLE_COLORS.primary : 'transparent',
            color: selected ? TRANSACTION_STYLE_COLORS.white : TRANSACTION_STYLE_COLORS.primary,
            '& .MuiTypography-root': {
              color: selected ? TRANSACTION_STYLE_COLORS.white : TRANSACTION_STYLE_COLORS.primary
            },
            '&:hover': {
              backgroundColor: selected
                ? TRANSACTION_STYLE_COLORS.primary
                : TRANSACTION_STYLE_COLORS.selected
            }
          };
        },
        pmButton: ({ ownerState }) => {
          const selected = ownerState?.meridiemMode === 'pm';
          return {
            backgroundColor: selected ? TRANSACTION_STYLE_COLORS.primary : 'transparent',
            color: selected ? TRANSACTION_STYLE_COLORS.white : TRANSACTION_STYLE_COLORS.primary,
            '& .MuiTypography-root': {
              color: selected ? TRANSACTION_STYLE_COLORS.white : TRANSACTION_STYLE_COLORS.primary
            },
            '&:hover': {
              backgroundColor: selected
                ? TRANSACTION_STYLE_COLORS.primary
                : TRANSACTION_STYLE_COLORS.selected
            }
          };
        }
      }
    }
  }
};

export const TRANSACTION_DATE_PICKER_POPPER_SX = {
  primaryColor: TRANSACTION_STYLE_COLORS.primary,
  paper: {
    background: TRANSACTION_STYLE_COLORS.white,
    borderRadius: '12px',
    boxShadow: '0 20px 25px -5px rgb(15 23 42 / 0.1), 0 8px 10px -6px rgb(15 23 42 / 0.1)',
    border: `1px solid ${TRANSACTION_STYLE_COLORS.border}`
  },
  day: {
    color: TRANSACTION_STYLE_COLORS.text,
    '&:hover': {
      background: TRANSACTION_STYLE_COLORS.selected,
      color: TRANSACTION_STYLE_COLORS.foreground,
      transform: 'none'
    }
  },
  selected: {
    background: `${TRANSACTION_STYLE_COLORS.primary} !important`,
    color: `${TRANSACTION_STYLE_COLORS.white} !important`
  },
  calendarHeader: {
    background: TRANSACTION_STYLE_COLORS.white,
    color: TRANSACTION_STYLE_COLORS.foreground,
    borderBottom: `1px solid ${TRANSACTION_STYLE_COLORS.separator}`
  },
  popper: {
    '& .MuiPickersCalendarHeader-iconButton': { color: TRANSACTION_STYLE_COLORS.muted },
    '& .MuiPickersArrowSwitcher-button': { color: TRANSACTION_STYLE_COLORS.muted },
    '& .MuiTypography-root': { color: 'inherit' },
    '& .MuiPickersDay-root.MuiPickersDay-today': {
      borderColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    },
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    },
    '& .MuiPickersDay-root.Mui-selected:hover': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`
    },
    '& .MuiClock-root': {
      backgroundColor: TRANSACTION_STYLE_COLORS.white
    },
    '& .MuiClockNumber-root': {
      color: TRANSACTION_STYLE_COLORS.text
    },
    '& .MuiClockNumber-root.Mui-selected': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    },
    '& .MuiClockPointer-root': {
      backgroundColor: TRANSACTION_STYLE_COLORS.primary
    },
    '& .MuiClockPointer-thumb': {
      backgroundColor: TRANSACTION_STYLE_COLORS.primary,
      borderColor: TRANSACTION_STYLE_COLORS.primary
    },
    '& .MuiClock-pin': {
      backgroundColor: TRANSACTION_STYLE_COLORS.primary
    },
    '& .MuiMultiSectionDigitalClock-root': {
      backgroundColor: TRANSACTION_STYLE_COLORS.white
    },
    '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    },
    '& .MuiMultiSectionDigitalClockSection-item:hover': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.selected} !important`,
      color: `${TRANSACTION_STYLE_COLORS.foreground} !important`
    },
    '& .MuiMultiSectionDigitalClockSection-item.Mui-selected:hover': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    },
    '& .MuiTimeClock-root .MuiTypography-root': {
      color: TRANSACTION_STYLE_COLORS.text
    },
    '& .MuiTimeClock-root .Mui-selected': {
      backgroundColor: `${TRANSACTION_STYLE_COLORS.primary} !important`,
      color: `${TRANSACTION_STYLE_COLORS.white} !important`
    }
  }
};

export const TRANSACTION_SELECT_MENU_PROPS = {
  PaperProps: {
    sx: {
      backgroundColor: TRANSACTION_STYLE_COLORS.white,
      color: TRANSACTION_STYLE_COLORS.foreground,
      border: `1px solid ${TRANSACTION_STYLE_COLORS.border}`,
      '& .MuiMenuItem-root': { color: TRANSACTION_STYLE_COLORS.text },
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: `${TRANSACTION_STYLE_COLORS.selected} !important`,
        color: TRANSACTION_STYLE_COLORS.foreground
      },
      '& .MuiMenuItem-root:hover, & .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: TRANSACTION_STYLE_COLORS.hover
      }
    }
  }
};
